import { Component, ErrorHandler, OnDestroy, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { Subject } from 'rxjs'

import { MatSnackBar } from '@angular/material/snack-bar'
import { ActionAfterAuthenticationLemonator, NetsTunnistauduRequest, NetsTunnistauduResponse } from '@lemon/core-firebase/model/tunnistaminen'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { TunnistautuminenService } from 'app/_angular/service/tunnistautuminen.service'
import { environment } from 'environments/environment'
import { LadataanService } from '../../_jaettu-angular/service/ladataan.service'

@Component({
  templateUrl: './nets-return.component.html',
  styleUrls: ['./nets-return.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TunnistautuminenNetsReturnComponent implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>()

  virhe: string = null
  year = new Date().getFullYear()

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _errorHandler: ErrorHandler,
    private _snackbar: MatSnackBar,
    private _ladataanService: LadataanService,
    private _router: Router,
    private _tunnistautuminenService: TunnistautuminenService,
    private _firebaseLemonator: FirebaseLemonator,
  ) {
    this._ladataanService.aloitaLataaminen()

    const errorCode = this._activatedRoute.snapshot.queryParamMap.get('error')
    const errorDescription = this._activatedRoute.snapshot.queryParamMap.get('error_description')
    const errorURIString = this._activatedRoute.snapshot.queryParamMap.get('error_uri')
    const code = this._activatedRoute.snapshot.queryParamMap.get('code')
    const stateHash = this._activatedRoute.snapshot.queryParamMap.get('state')

    const clientSession = this._tunnistautuminenService.getClientSideAuthenticationSession()

    if (!clientSession) {
      this._errorHandler.handleError(new Error('Tunnistautumissession dataa ei löytynyt Session Storagesta!'))
    }

    if (errorCode || errorDescription || errorURIString) {
      this._ladataanService.lopetaLataaminen()
      this._errorHandler.handleError(new Error('Error in strong auth return component: ' + errorCode + ' ,__, ' + errorDescription + ' ,__, ' + errorURIString))
      this._tunnistautuminenService.setTunnistautuminenState(errorCode === 'cancel' ? 'error-cancel' : 'error')
      this._tunnistautuminenService.navigateByAction(clientSession.action)
    } else if (clientSession && code && stateHash) {
      const pyynto: NetsTunnistauduRequest = {
        avain: clientSession.sessionAvain,
        code: code,
        state: clientSession.state,
        stateHash: stateHash,
        env: this._tunnistautuminenService.getNetsEnvironment(environment.environment),
        device: navigator.platform,
        os: navigator.userAgent,
        version: environment.version,
      }

      const func = this._getFunctionByAction(clientSession.action)
      this._firebaseLemonator
        .functionsCall<NetsTunnistauduRequest, NetsTunnistauduResponse>(func, pyynto)
        .then(vastaus => {
          if (vastaus.result === 'success') {
            this._ladataanService.lopetaLataaminen()
            this._tunnistautuminenService.setTunnistautuminenState('success')
            this._tunnistautuminenService.endClientSideAuthenticationSession()
            this._tunnistautuminenService.navigateByAction(clientSession.action, vastaus.data)
          } else {
            this._ladataanService.lopetaLataaminen()
            this._errorHandler.handleError('Backend error while checking NETS authentication.')
            this._tunnistautuminenService.setTunnistautuminenState('error')
            this._tunnistautuminenService.navigateByAction(clientSession.action)
          }
        })
        .catch(err => {
          this._ladataanService.lopetaLataaminen()
          this._errorHandler.handleError(err)
          this._tunnistautuminenService.setTunnistautuminenState('error')
          this._tunnistautuminenService.navigateByAction(clientSession.action)
        })
    } else {
      this._ladataanService.lopetaLataaminen()
      this._errorHandler.handleError(
        new Error('Error in strong auth return component: Missing client session, code or state. Client session: ' + clientSession?.sessionAvain + ', Code: ' + code + ', state: ' + stateHash),
      )
      this._tunnistautuminenService.setTunnistautuminenState('error')
      this._tunnistautuminenService.navigateByAction(clientSession.action)
    }
  }

  private _getFunctionByAction(action: ActionAfterAuthenticationLemonator): string {
    if (action === 'continue-tilintarkastaja-tunnistautuminen') {
      return 'tilintarkastajatTarkistaTunnistautuminen'
    }
    if (action === 'continue-tilintarkastaja-kirjautuminen') {
      return 'tilintarkastajatTarkistaKirjautuminen'
    }
    return null
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }
}
